import { withTranslation } from "react-i18next";
import RatingList from './RatingList';

export default withTranslation(undefined, { withRef: true })(RatingList);